import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import initScrollTrigger from '../helpers/initScrollTrigger';
import сustomPageScroll from '../components/custom-scroll';


gsap.registerPlugin(ScrollTrigger);
initScrollTrigger();

const refreshScrollAndTriggers = () => {

	сustomPageScroll.scroller.update();
	const triggers = ScrollTrigger.getAll();
	triggers.forEach((trigger) => {
		trigger.refresh();
	});
}

export default refreshScrollAndTriggers;
